
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import LinkBase from '@/components/atoms/LinkBase.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import PageLinkButton from '@/components/organisms/PageLinkButton.vue'
import PulldownFilter from '@/components/organisms/PulldownFilter.vue'
import NoticeListElement from '@/components/organisms/NoticeListElement.vue'
import { SelectItem } from '@/models/SelectItem'
import { NoticeMessageData } from '@/models/NoticeMessage'

/**
 * お知らせ一覧パネル
 */
@Component({
  components: {
    PanelFrame,
    ImageBase,
    LinkBase,
    PulldownFilter,
    NoticeListElement,
    PageLinkButton,
  },
})
export default class NoticeListPanel extends Vue {
  /** お知らせタイプ選択 */
  @Ref()
  notificationTypePulldown!: PulldownFilter

  /** 年選択 */
  @Ref()
  selectYearPulldown?: PulldownFilter

  /** 月選択 */
  @Ref()
  selectMonthPulldown?: PulldownFilter

  /** お知らせタイプの初期値 */
  @Prop()
  private defaultNotificationTypeCode!: string

  /** お知らせタイプのリスト */
  @Prop()
  private notificationTypeList!: SelectItem[]

  /** 年の初期値 */
  @Prop()
  private defaultYearCode?: string

  /** 年のリスト */
  @Prop()
  private selectYearList?: SelectItem[]

  /** 月の初期値 */
  @Prop()
  private defaultMonthCode?: string

  /** 月のリスト */
  @Prop()
  private selectMonthList?: SelectItem[]

  /** メッセージ一覧 */
  @Prop()
  private messageList!: NoticeMessageData[]

  /** ページ数 */
  @Prop()
  private pageLength!: number

  /** 現在のページ */
  @Prop()
  private currentPage!: number

  /** ソート順の変更 */
  @Prop()
  private toggleSortOrder?: () => void

  /** ページリンクボタン押下時のイベント */
  @Prop()
  private changePage!: (value: number) => void

  /** 行クリック時のイベント */
  @Prop()
  private eventClickElement!: (id: number) => void

  /** ソートインジケーターの状態 */
  @Prop()
  private sortIndicator?: boolean

  /**
   * 選択中のお知らせタイプ
   *
   * @returns お知らせタイプのコード
   */
  public currentNotificationTypeCode(): string {
    // undefinedケース 発生しないがブロックのため記述
    if (!this.notificationTypePulldown) {
      return ''
    }
    return this.notificationTypePulldown.selectedValue()
  }

  /**
   * 選択中の年
   *
   * @returns 年のコード
   */
  public currentYearCode(): string {
    // undefinedケース
    if (!this.selectYearPulldown) {
      return ''
    }
    return this.selectYearPulldown.selectedValue()
  }

  /**
   * 選択中の月
   *
   * @returns 月のコード
   */
  public currentMonthCode(): string {
    // undefinedケース
    if (!this.selectMonthPulldown) {
      return ''
    }
    return this.selectMonthPulldown.selectedValue()
  }

  /** フィルターの変更を検知してイベント発火させる */
  private changeFilter(): void {
    this.$emit('changeFilter')
  }
}
